import { ParamErrCode } from './types';
import type { ErrCode } from './types';

export class CommonError extends Error {

  code: ErrCode = ParamErrCode.COMMON;

  constructor(message = 'Error', code?: ErrCode) {
    super(message);

    // safari等非chrome浏览器没有这个方法
    if (Error.captureStackTrace != null) {
      Error.captureStackTrace(this, this.constructor);
    }

    // Webpack等工具进行代码转换时，原型链可能会被修改或丢失
    Object.setPrototypeOf(this, CommonError.prototype);
    this.code = code ?? this.code;
  }

  static isCommonError(error: unknown): error is CommonError {
    return error instanceof CommonError;
  }

}
